// Import Firebase and Firebase Messaging (modular SDK)
import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";
var firebaseConfig = {
  apiKey: "AIzaSyB1sMuzKVRmoqiDC3Yae0ru5OtsgpMVoeA",
  authDomain: "tegsofttouch.firebaseapp.com",
  databaseURL: "https://tegsofttouch.firebaseio.com",
  projectId: "tegsofttouch",
  storageBucket: "tegsofttouch.appspot.com",
  messagingSenderId: "974152358637",
  appId: "1:974152358637:web:611bea724ec1e5a0448ae4",
  measurementId: "G-VJ341BJ1G3",
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Initialize Firebase Messaging
const messaging = getMessaging(app);

export default messaging;
